module.exports = __webpack_public_path__ + "static/img/timeless.86bedbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial/timeless.png
// module id = PEHi
// module chunks = 38